module.exports = __webpack_public_path__ + "static/img/thumb-02.068f001.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/flash/thumb/thumb-02.png
// module id = 6xj+
// module chunks = 150